import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=dc042ff4"
import script from "./ActionButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionButton.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports